/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactLookupResult } from './contactLookupResult.js';


export interface ContactSearchHistoryEntry { 
    /**
     * The search term that was used
     */
    query: string;
    /**
     * Whether the search was performed by phone number or by name
     */
    searchType: ContactSearchHistoryEntry.SearchTypeEnum;
    /**
     * Timestamp of when the search was performed
     */
    searchedAt: string;
    /**
     * Contacts that matched the search, empty when none were found
     */
    results: Array<ContactLookupResult>;
}
export namespace ContactSearchHistoryEntry {
    export type SearchTypeEnum = 'name' | 'phone';
    export const SearchTypeEnum = {
        name: 'name' as SearchTypeEnum,
        phone: 'phone' as SearchTypeEnum
    };
}


